/* Native color labels, shared by cards and product pickers. No variant or cart state. */
(() => {
  if (window.__rizonVariantTooltips) return;
  window.__rizonVariantTooltips = true;
  const selector = '[data-variant-tooltip]';
  const tip = document.createElement('div');
  tip.id = 'rizon-variant-tooltip';
  tip.className = 'variant-tooltip';
  tip.setAttribute('role', 'tooltip');
  tip.hidden = true;
  const text = document.createElement('span'), arrow = document.createElement('span');
  arrow.className = 'variant-tooltip__arrow'; arrow.setAttribute('aria-hidden', 'true');
  tip.append(text, arrow);
  const topLayer = typeof tip.showPopover === 'function';
  if (topLayer) tip.setAttribute('popover', 'manual');
  document.body.append(tip);
  let trigger, described, originalTitle, closeTimer, leaveTimer, frame;
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const owner = target => target?.closest?.(selector) || [...target?.labels || []].find(label => label.matches(selector));
  const control = element => element.control || element;
  const clearDescription = () => {
    if (!described) return;
    const ids = (described.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== tip.id);
    if (ids.length) described.setAttribute('aria-describedby', ids.join(' ')); else described.removeAttribute('aria-describedby');
    described = null;
  };
  const finish = () => {
    if (topLayer && tip.matches(':popover-open')) tip.hidePopover();
    tip.hidden = true;
  };
  const hide = (immediate = false) => {
    clearTimeout(leaveTimer); clearTimeout(closeTimer); cancelAnimationFrame(frame);
    if (trigger && originalTitle !== null) trigger.setAttribute('title', originalTitle);
    clearDescription(); trigger = null; originalTitle = null;
    tip.removeAttribute('data-visible');
    if (immediate || reduced()) finish(); else closeTimer = setTimeout(finish, 500);
  };
  const place = () => {
    if (!trigger?.isConnected) return hide(true);
    const rect = trigger.getBoundingClientRect(), box = tip.getBoundingClientRect();
    const x = Math.max(8, Math.min(innerWidth - box.width - 8, rect.left + rect.width / 2 - box.width / 2));
    const below = rect.top < box.height + 20;
    const y = below ? rect.bottom + 12 : rect.top - box.height - 12;
    let originX = 0, originY = 0;
    // Older browsers without the top layer keep the tooltip in its owning dialog.
    if (!topLayer && tip.parentElement !== document.body) {
      const host = tip.parentElement, origin = host.getBoundingClientRect();
      originX = origin.left + host.clientLeft - host.scrollLeft;
      originY = origin.top + host.clientTop - host.scrollTop;
    }
    tip.style.left = `${x - originX}px`; tip.style.top = `${y - originY}px`;
    tip.toggleAttribute('data-below', below);
    arrow.style.left = `${Math.max(10, Math.min(box.width - 10, rect.left + rect.width / 2 - x))}px`;
  };
  const show = element => {
    clearTimeout(leaveTimer);
    if (!element?.dataset.variantTooltip || element === trigger) return;
    hide(true); trigger = element; originalTitle = element.getAttribute('title'); element.removeAttribute('title');
    text.textContent = element.dataset.variantTooltip;
    described = control(element);
    const ids = (described.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    described.setAttribute('aria-describedby', [...new Set([...ids, tip.id])].join(' '));
    // A modal makes everything outside its subtree inert, even a later popover.
    // Keep semantic ownership inside the dialog; the top layer still escapes clipping.
    const host = element.closest('dialog[open]') || document.body;
    host.append(tip);
    if (!topLayer) tip.style.position = host === document.body ? 'fixed' : 'absolute';
    tip.hidden = false;
    if (topLayer) tip.showPopover();
    place(); void tip.offsetWidth;
    frame = requestAnimationFrame(() => tip.setAttribute('data-visible', ''));
  };
  const deferHide = () => { clearTimeout(leaveTimer); leaveTimer = setTimeout(() => hide(), 120); };
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    if (tip.contains(event.target)) { clearTimeout(leaveTimer); return; }
    const element = owner(event.target); if (element) show(element);
  });
  document.addEventListener('pointerout', event => {
    if (!trigger || (!trigger.contains(event.target) && !tip.contains(event.target))) return;
    if (trigger.contains(event.relatedTarget) || tip.contains(event.relatedTarget)) return;
    if (described === document.activeElement && described.matches(':focus-visible')) return;
    deferHide();
  });
  document.addEventListener('focusin', event => { const element = owner(event.target); if (element && event.target.matches(':focus-visible')) show(element); });
  document.addEventListener('focusout', event => { if (event.target === described) hide(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') hide(true); });
  document.addEventListener('close', () => hide(true), true);
  document.addEventListener('shopify:section:unload', event => { if (trigger && event.target.contains(trigger)) hide(true); });
  // Scrolling must not kill the tooltip outright. This listener captures scroll
  // from any element, so a horizontal carousel settling under the pointer - the
  // homepage sliders use scroll snap - counted as "the page moved" and hid a
  // tooltip that had only just been built. Follow the swatch instead, and let go
  // only once it has actually left the viewport.
  window.addEventListener('scroll', () => {
    if (!trigger) return;
    const rect = trigger.getBoundingClientRect();
    const gone = rect.bottom < 0 || rect.top > innerHeight || rect.right < 0 || rect.left > innerWidth;
    if (gone) hide(true); else place();
  }, { passive: true, capture: true });
  window.addEventListener('resize', () => { if (trigger) place(); });
  new MutationObserver(() => { if (trigger && !trigger.isConnected) hide(true); }).observe(document.body, { childList: true, subtree: true });
})();
